import { getFinalCommonColumns, initialCommonColumns } from "./index";
import { colSettings } from "../../../common/components/table/agGrid/colSettings";
import { marketDynamicsColumns as mdCols } from "../marketDynamicsColumns";

export const getExpiredColumns = shouldShowAdditionalInfoCols =>[
    ...initialCommonColumns,
    { col: mdCols.price, colDef: colSettings.numberSmVolume },
    { col: mdCols.offMarketDate, colDef: colSettings.dateMd },
    ...getFinalCommonColumns(shouldShowAdditionalInfoCols),
];
